/** True when a config value is a server-side masked secret (e.g. `abcd****`). */
export function isMaskedSecret(value: unknown): boolean {
  return typeof value === 'string' && value.includes('****');
}
